import { createSlice } from '@reduxjs/toolkit';
export interface DataState {
  data: any;
  
}
const initialState: DataState = {
 data:'',
};

export const destinationSystemSlice = createSlice({
  name: 'setDsystem',
  initialState,
  reducers: {
    setdysData: (state, action) => {
      state.data = action.payload;
    },
  },
});
export const { setdysData } = destinationSystemSlice.actions;
export default destinationSystemSlice.reducer;
